import { Skiptrace } from 'features/Skiptrace/domain/Skiptrace.domain'
import { mapGetSkiptraceResultResponse } from 'features/Skiptrace/infra/remote/getSkiptraceResult/getSkiptraceResult.mapper'
import { getTracers } from 'features/Skiptrace/infra/remote/getTracers/getTracers'
import { restClient } from 'presentation/libs/client'

/** @TODO Caching */
export const getSkiptraceResult = async (
  { leadId, address }: Skiptrace.GetSkiptraceResultPayload,
): Promise<Skiptrace.GetSkiptraceResultResult> => {
  const response = await restClient.post('marketing/v2/skiptrace/v4/search', {
    json: [{
      type: 'basic',
      line1: address.line1,
      city: address.city,
      state: address.state,
      zip: address.postalCode,
    }],
  }).json<any>()

  const skiptraces = Array.isArray(response?.[0])
    ? response[0]
    : []

  // The v4 search endpoint returns newest-first across all statuses. The screen
  // wants the latest completed result so a newer failed/processing attempt does
  // not hide the last usable skiptrace.
  const needsTracerLookup = skiptraces.some(
    skiptrace => skiptrace?.status === 'completed',
  )

  const tracers = needsTracerLookup
    ? await getTracers().then(tracersResponse => tracersResponse.tracers)
    : []

  return mapGetSkiptraceResultResponse({
    leadId,
    address,
    skiptraces,
    tracers,
  })
}
